export const getDialogOverrides = theme => ({
  MuiDialog: {
    styleOverrides: {
      root: {
        padding: `${theme.spacing(3)} ${theme.spacing(3.5)}`
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: 0,
        paddingBottom: theme.spacing(3)
      }
    }
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        marginBottom: theme.spacing(1),
        padding: 0,
        color: theme.palette.text.primary
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: 0
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 0,
        marginTop: theme.spacing(1)
      }
    }
  }
});